'use strict';

import { isDesktopLarge } from '../helpers/responsiveViewport';

var onMustacheLoaded = require('./mustacheLoad');
var getMustacheFiles = require('./loadMustachesFiles');
var checkEmptyModuleSection = require('./checkEmptyModules');
var prettifyUrlInReviewLists = require('./prettifyBigURLs');
var reviewScore = require('./reviewScore');
var calculTopBars = require('../review/dashboard/dashboardProgressStatus');
var scrollToElement = require('../helpers/scrollToElement');
var getParameterByName = require('../helpers/getParameterByName');
var initWooFlyingMenu = require('../helpers/leftMenu');
var cleanWooRankLinks = require('../helpers/cleanWoorankLinks');
var gotoGet = getParameterByName('goto');
var renderCharts = require('../charts/chartsRender');
var competizeAll = require('../review/competitors/competizeAll');
var pdfPopover = require('../pdf/pdfPopover');

require('../modals/createAdvancedReview');

window.isInsideReview = $('#dashboard-content').hasClass('inside-page');
window.isAdvancedReview = $('body').hasClass('enrichrev');
window.currentWebsite = $('#dashboard-site > h1 > a').data('url');
window.isSharedReview = $('body').hasClass('shared');

function listenForScrollEvents () {
  window.addEventListener('message', function (e) {
    if (e.data && e.data.indexOf('com.woorank.parent_scroll') === 0) {
      const defaultMargin = (isDesktopLarge) ? 0 : 60;
      const menuTop = defaultMargin + Math.max(0, parseInt(e.data.split('_').pop(), 10));

      $('#flying')
        .addClass('is-flying')
        .css('top', menuTop + 'px');
    }
  });
}

function postMessage (message) {
  if (window.opener || window.top) {
    (window.opener || window.top).postMessage(message, '*');
  }
}

function postHeight () {
  return setTimeout(() => {
    const lastModule = $('.module').last();
    var height = lastModule.position().top + lastModule.height();
    postMessage('com.woorank.height_' + height);
  }, 100);
}

function targetBlankLinks () {
  $('a').attr('target', '_blank');
}

postHeight();
window.addEventListener('crit-html-changed', postHeight, false);
$('.module').on('click', '.show-links a', postHeight);

if (window.wooGlobal.allLinksTargetBlank === true) {
  targetBlankLinks();
  window.addEventListener('crit-html-changed', targetBlankLinks, false);
}

if (window.isSharedReview) {
  window.ajaxPjDataProxyUrl =
    window.location.pathname.replace('public', 'pub-data') + '?u=';
  cleanWooRankLinks();
}

if (!window.isMobile) {
  initWooFlyingMenu();

  const initFlyingMenuInIframe = function (e) {
    window.removeEventListener('message', initFlyingMenuInIframe);
    // Handle the sidebar links
    $('#flying')
      .css('transition', 'top 0.25s ease-out') // We want the menu to fly smoothly when scrolled
      .find('.inpage-link')
      .off('click')
      .on('click', function (event) {
        event.preventDefault();

        const $element = $(this.getAttribute('href'));
        postMessage('com.woorank.scrollto_' + $element.offset().top);
      });

    $('.criterium').on('click', (e) => { postHeight(); }); // Update on advice click

    listenForScrollEvents();
  };

  window.addEventListener('message', function (e) {
    if (typeof e.data === 'string' && e.data.indexOf('com.woorank.init_frame') === 0) {
      initFlyingMenuInIframe();
    }
  });
}

if (!window.isInsideReview) {
  reviewScore.init();
}

require('./openCriterium');
require('./showMoreTask');
require('./dashboard/dashboard');
require('./marketing-tasks/marketingTasks')();
require('./reviewRegeneration');

getMustacheFiles().then(onMustacheLoaded);

checkEmptyModuleSection();

if (window.isMobile) {
  $('#report-content').show();
}

calculTopBars();
prettifyUrlInReviewLists();

$('body').externalLinks();
$('body').truncate();

postMessage('com.woorank.ready_to_receive');

// if ?goto= isset then go to this section
if (gotoGet && gotoGet !== '') {
  scrollToElement($('#' + gotoGet));
}

if (!window.isInside) {
  competizeAll(true);
}

renderCharts();

pdfPopover();
